import React from 'react';
import styled from 'styled-components';

import Text from '../components/Text';

const colors = ['#9b59b6', '#1e8bc3', '#23cba7', '#f5d76e', '#eb974e', '#6c7a89', '#d64541'];

const AppIconContainer = styled.div<{size: string, colorIndex: number}>`
  height: ${({ size, theme: { units } }) => units.sizes[`element_${size}`.toUpperCase()]};
  width: ${({ size, theme: { units } }) => units.sizes[`element_${size}`.toUpperCase()]};
  background-color ${({ colorIndex }) => colors[colorIndex]};
  border-radius: 27px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  border: solid 1px ${({ theme: { colors } }) => colors.general.SOFT_GRAY};
`;

const AppText = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2.8em;
`;

const AppImage = styled.img<{size: string}>`
  width: ${({ size, theme: { units } }) => units.sizes[`element_${size}`.toUpperCase()]};
`;

interface AppIconProps {
  size: 'small' | 'normal' | 'large' | 'xlarge',
  icon: string,
  appName: string,
  className: string,
}

function AppIcon({
  size, icon, appName,
  className,
}: AppIconProps) {
  return (
    <AppIconContainer className={`${className}`} size={size} colorIndex={Math.floor(Math.random() * (6 - 0 + 1)) + 0}>
      {
        !icon ? (
          <AppText>
            { `${appName}`[0].toUpperCase() }
          </AppText>
        ) : <AppImage src={icon} size={size} />
      }
    </AppIconContainer>
  );
}

export default AppIcon;

AppIcon.defaultProps = {
  size: 'large',
  icon: null,
  appName: 'App',
  className: '',
}
